// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"367aa669","455":"387f1ca2","977":"7ff9bab6"}[chunkId] + ".chunk.js";
};